.pager {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: 3px var(--spacing-sm);

  .pager__left {
    min-width: 65px;
  }

  .pager-button-disabled svg {
    fill: lightgray;
    cursor: not-allowed;
  }
}
